import React from 'react'

export default () => <h3>LegalNotice</h3>
